module.exports = __webpack_public_path__ + "img/027.736acd90.png";